export default __webpack_public_path__ + "static/media/image_icon.e6e3534e.svg";